import React from "react";
import { Link } from "react-router-dom";
import useControlledNavigation from "../hooks/useControlledNavigation";
import { handleFreeze } from "../utils/common";
import { showWarningSnackbar } from "./snackBar/snakbar";
import { useDispatch, useSelector } from "react-redux";
import { settingsClose } from "../redux/reducers/companySkipSave";

function LinkTagComponent(props) {
  const navigate = useControlledNavigation();

  const { id, to, children, ...rest } = props;
  let dispatch = useDispatch();
  const { saveSkipStatus } = useSelector(
    (state) => state.companySipSaveReducer
  );
  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );
  const handleNavigation = (e, to) => {
    if (to) {
      navigate(to);
    }
  };
  const RoutesArray = [
    "/additem",
    "/addcustomer",
    "/addsupplier",
    "/addnewinvoicetax",
    "/newpos",
    "/addnewpurchasetax",
    "/adddebitnote",
    "/addcreditnote",
    "/addreceipts",
    "/addjournalentry",
    "/addpaymententries",
  ];
  return (
    <Link
      {...props}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (RoutesArray.includes(to)) {
          if (Freeze) {
            return handleFreeze();
          }
          if (saveSkipStatus == false) {
            if (window.location.href.includes("companysetup")) {
              showWarningSnackbar("Please Complete the Company Setup Details");
            }
            dispatch(settingsClose());
            return navigate("/companysetup");
          }
          handleNavigation(e, to);
        } else {
          handleNavigation(e, to);
        }
      }}
    >
      {children}
    </Link>
  );
}

export default LinkTagComponent;
